"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var styles_1 = require("../styles");
var TableSortLabel_1 = require("../TableSortLabel");
/** @deprecated Will be removed in a future major release */
var DataGridHeadCell = /** @class */ (function (_super) {
    __extends(DataGridHeadCell, _super);
    function DataGridHeadCell() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataGridHeadCell.prototype.render = function () {
        var _a = this.props, classes = _a.classes, column = _a.column, testId = _a.testId;
        var label = column.label, width = column.width, active = column.active, sortDirection = column.sortDirection, onClick = column.onClick;
        return (react_1.default.createElement("div", { className: classes.tableHeadCell, "data-testid": testId },
            react_1.default.createElement(TableSortLabel_1.TableSortLabel, { active: active, hideSortIcon: true, direction: sortDirection ? sortDirection : undefined, onClick: onClick, classes: {
                    root: classes.headerLabel,
                    icon: classes.sortIcon,
                }, style: {
                    width: "".concat(width - 25, "px"),
                } }, label)));
    };
    return DataGridHeadCell;
}(react_1.Component));
DataGridHeadCell.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    column: prop_types_1.default.object,
    testId: prop_types_1.default.string,
};
var styles = function (theme) { return ({
    tableHeadCell: __assign(__assign({ textAlign: 'left' }, theme.typography.subtitle2), { color: theme.palette.primary.contrastText, backgroundColor: theme.palette.primary.main, height: '100%', width: '100%', border: 'none !important' }),
    headerLabel: {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        margin: theme.spacing(1),
        color: "".concat(theme.palette.primary.contrastText, " !important"),
        '&:hover': {
            color: theme.palette.primary.contrastText,
            opacity: 0.7,
        },
    },
    sortIcon: {
        verticalAlign: 'middle',
        color: "".concat(theme.palette.primary.contrastText, " !important"), // important to overwrite focus/active color
    },
}); };
/** @deprecated Will be removed in a future major release */
exports.default = (0, styles_1.withStyles)(styles, { withTheme: true })(DataGridHeadCell);
//# sourceMappingURL=DataGridHeadCell.js.map